<template>
    <div class="pagination">
        <div class="item" @click='change(active-1)' v-if="active != 1">&lt;&lt;</div>
        <div class="item" v-for="item in page" :key="item" :class="{active: active == item}" @click='change(item)'>{{item}}</div>
        <div class="item" @click='change(active+1)' v-if="active != page">&gt;&gt;</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                active: 1,
            }
        },
        props: ['page'],
        components: {
            
        },
        watch: {
            
        },
        mounted() {
            
        },
        destroyed(){
            
        },
        methods: {
            change(page){
                this.active = page;
                this.$emit('change', page);
            }
        }
    }
</script>

<style lang="scss" scoped>
.pagination{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 50px;
    .item{
        width: 35px;
        height: 35px;
        line-height: 35px;
        background: #fff;
        color: rgba(0,0,0,.5);
        margin-left: 10px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        &.active,
        &:hover{
            background: #184a8d;
            color: #fff;
        }
        &.active{
            cursor: auto;
        }
    }
    @media only screen and (max-width: 1024px) {
        justify-content: center;
        margin-top: .5rem;
        .item{
            width: .6rem;
            height: .6rem;
            line-height: .6rem;
            margin: 0 .1rem;
            &:hover{
                background: #fff;
                color: rgba(0,0,0,.5);
            }
            &.active{
                background: #184a8d;
                color: #fff;
            }
        }
    }
}
</style>